const getCurrentLineHeight = (editor) => {
  const lineHeight = editor.getAttributes('textStyle').lineHeight;
  return parseFloat(lineHeight) || 1;
};

const setLineHeight = (editor, { value: lineHeight }) => {
  const height = parseFloat(lineHeight) || 1;
  editor.chain().focus().setLineHeight(`${height}`).run();
};

const unsetLineHeight = (editor) => {
  editor.chain().focus().unsetLineHeight().run();
};

const increaseLineHeight = (editor) => {
  const nextLineHeight = Math.round((getCurrentLineHeight(editor) + 0.1) * 10) / 10;
  editor.chain().focus().setLineHeight(`${nextLineHeight}`).run();
};

const decreaseLineHeight = (editor) => {
  const previousHeight = Math.round((getCurrentLineHeight(editor) - 0.1) * 10) / 10;
  const previousLineHeight = Math.max(0.1, previousHeight);
  editor.chain().focus().setLineHeight(`${previousLineHeight}`).run();
};

export default {
  'line:height:set': setLineHeight,
  'line:height:unset': unsetLineHeight,
  'line:height:increase': increaseLineHeight,
  'line:height:decrease': decreaseLineHeight,
};
